import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import * as labels from "../components/localized/labels.js";

const get_url = (method) => {
    return `${process.env.REACT_APP_API_URL}/${method}`
}

const downloadFile = function (method, params) {

    var url = `${process.env.REACT_APP_API_URL}/${method}`;


    return new Promise(function (resolve, reject) {


        const { body, token } = params;

        var headers = {
            "Content-Type": "application/json",
            'Accept': 'application/json',
        };

        if (params.user && params.user.token) {
            headers["Authorization"] = params.user.token;
        }

        var result = fetch(url, {
            //api allowed verb is POST
            method: 'POST',
            //headers
            headers: headers,
            //body
            body: body ? JSON.stringify(body) : null
        })
            .then(r => r.blob())
            .then(b => resolve(b))
            .catch(error => {
                reject(error);
            });
    });
}

const downloadFileGet = function (method, params = {}) {
    return new Promise(function (resolve, reject) {
        var url = `${process.env.REACT_APP_API_URL}/${method}`;

        var headers = {
            'Accept': 'application/octet-stream, */*',
        };

        if (params.user && params.user.token) {
            let token = params.user.token;
            
      

            headers["Authorization"] = token; // <--- Ora invia "Bearer <token>"
            
            var lang = params.user && params.user._language ? `${params.user._language}-${params.user._language.toUpperCase()}` : "en"
            if (!params.user.language || !params.user.language) {
                lang = localStorage.getItem("active_language") || "en";
            }
            headers["Language"] = lang;
        }
        else {
            const lang = localStorage.getItem("active_language") || "en";
            headers["Language"] = lang;
        }

        fetch(url, {
            method: 'GET',
            headers: headers
        })
        // ... il resto della funzione fetch rimane invariato ...
        .then(r => {
            if (r.headers.has('X-Auth-Token')) {
                const _user = JSON.parse(localStorage.getItem('user'));
                // Assicurati che anche qui il nuovo token venga salvato correttamente (opzionale)
                let newToken = r.headers.get("X-Auth-Token");
        
                _user.token = newToken;
                localStorage.setItem('user', JSON.stringify(_user));
            }
            
            // Check for 401 status (Unauthorized)
            if (r.status === 401 || r.status===403) {
                return r.json().then(data => {
                    return data;
                });
            }
            
            // For binary files, return blob instead of json
            return r.blob();
        })
        .then(blob => {
            resolve(blob);
        })
        .catch(error => {
            if (!params.silentMode) {
                // Logica di errore
            }
            reject(error);
        });
    });
}
const sendMessage = function (method, params) {
    return new Promise(function (resolve, reject) {
        var url = `${process.env.REACT_APP_API_URL}/${method}`;

        const { body, token } = params;

        var headers = {
            "Content-Type": "application/json",
            'Accept': 'application/json',
        };


        if (params.user && params.user.token) {
            headers["Authorization"] = params.user.token;
            var lang = params.user && params.user._language ? `${params.user._language}-${params.user._language.toUpperCase()}` : "en"
            if (!params.user.language || !params.user.language) {
                lang = localStorage.getItem("active_language") || "en";
            }
            headers["Language"] = lang;
        }
        else { //in case of registration
            const lang = localStorage.getItem("active_language") || "en";
            headers["Language"] = lang;
        }

        var result = fetch(url, {
            //api allowed verb is POST
            method: 'POST',
            //headers
            headers: headers,
            //body
            body: body ? JSON.stringify(body) : null,

        })
            .then(r => {
                if (r.headers.has('X-Auth-Token')) {
                    const _user = JSON.parse(localStorage.getItem('user'));
                    _user.token = r.headers.get("X-Auth-Token");
                    localStorage.setItem('user', JSON.stringify(_user));
                }
                
                // Check for 401 status (Unauthorized)
                if (r.status === 401) {
                    return r.json().then(data => {
                        if (data.redirectLogin) {
                            localStorage.removeItem("user");
                            window.location.href = "/login";
                            return Promise.reject(new Error('Unauthorized - redirecting to login'));
                        }
                        return data;
                    });
                }
                
                return r.json();
            })
            .then((data) => {
                resolve(data);

                if (data.error) {
                    withReactContent(Swal).fire({
                        title: "ERROR",
                        icon: "error",
                        text: data.error,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        showCloseButton: true,
                    });

                    if (data.removeToken) {
                        localStorage.removeItem("user");
                        window.location.href = "/login";
                    }
                }

                // Handle redirectLogin even if there's no error field
                if (data.redirectLogin) {
                    localStorage.removeItem("user");
                    window.location.href = "/login";
                }
            })
            .catch(error => {
                const isDebug = process.env.REACT_APP_IS_DEBUG === 'true';
                console.error(`[API] ${method} failed`, { url, errorName: error?.name, errorMessage: error?.message });
                if (!params.silentMode) {
                    const debugHtml = isDebug
                        ? `<br/><small style="font-family:monospace;text-align:left;display:block;margin-top:8px;color:#aaa">` +
                          `<b>URL:</b> ${url}<br/>` +
                          `<b>Error:</b> ${error?.name}: ${error?.message}<br/>` +
                          `<b>Hint:</b> ${error?.name === 'TypeError' ? 'Server irraggiungibile, CORS o certificato SSL' : 'Errore di rete generico'}` +
                          `</small>`
                        : '';
                    withReactContent(Swal).fire({
                        title: "ERROR",
                        icon: "error",
                        html: `${labels.getText()["ERROR_WHILE_CONNECTING_TO_SERVER"]()}${debugHtml}`,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        showCloseButton: true,
                    });
                }
                reject(error);
            });
    });
}

const sendGetRequest = function (method, params ) {
    return new Promise(function (resolve, reject) {
        var url = `${process.env.REACT_APP_API_URL}/${method}`;

        var headers = {
            "Content-Type": "application/json",
            'Accept': 'application/json',
        };

        if (params.user && params.user.token) {
            headers["Authorization"] = params.user.token;
            var lang = params.user && params.user._language ? `${params.user._language}-${params.user._language.toUpperCase()}` : "en"
            if (!params.user.language || !params.user.language) {
                lang = localStorage.getItem("active_language") || "en";
            }
            headers["Language"] = lang;
        }
        else {
            const lang = localStorage.getItem("active_language") || "en";
            headers["Language"] = lang;
        }

        fetch(url, {
            method: 'GET',
            headers: headers
        })
            .then(r => {
                if (r.headers.has('X-Auth-Token')) {
                    const _user = JSON.parse(localStorage.getItem('user'));
                    _user.token = r.headers.get("X-Auth-Token");
                    localStorage.setItem('user', JSON.stringify(_user));
                }
                
                // Check for 401 status (Unauthorized)
                if (r.status === 401) {
                    return r.json().then(data => {
                        if (data.redirectLogin) {
                            localStorage.removeItem("user");
                            window.location.href = "/login";
                            return Promise.reject(new Error('Unauthorized - redirecting to login'));
                        }
                        return data;
                    });
                }
                
                return r.json();
            })
            .then((data) => {
                resolve(data);

                if (data.error) {
                    withReactContent(Swal).fire({
                        title: "ERROR",
                        icon: "error",
                        text: data.error,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        showCloseButton: true,
                    });

                    if (data.removeToken) {
                        localStorage.removeItem("user");
                        window.location.href = "/login";
                    }
                }

                // Handle redirectLogin even if there's no error field
                if (data.redirectLogin) {
                    localStorage.removeItem("user");
                    window.location.href = "/login";
                }
            })
            .catch(error => {
                if (!params.silentMode) {
                    withReactContent(Swal).fire({
                        title: "ERROR",
                        icon: "error",
                        text: error.message,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        showCloseButton: true,
                    });
                }
                reject(error);
            });
    });
}


/**
 * Establishes Server-Sent Events (SSE) connection for real-time data streaming
 * Used for collaborative form locking to maintain persistent connection with server
 *
 * @param {string} method - API endpoint (e.g., "darm/formCompletion/lock/connect")
 * @param {object} params - Parameters object containing:
 *   - user: User object with authentication token
 *   - body: Request body data
 *   - signal: Optional AbortController signal for cancellation
 * @returns {Promise<Response>} Raw fetch Response object with readable stream
 *
 * @example
 * const response = await connectSSE("darm/formCompletion/lock/connect", {
 *   user: currentUser(),
 *   body: { completionId: "uuid" },
 *   signal: abortController.signal
 * });
 */
const connectSSE = function (method, params) {
    return new Promise(function (resolve, reject) {
        var url = `${process.env.REACT_APP_API_URL}/${method}`;

        const { body, signal } = params;

        var headers = {
            "Content-Type": "application/json",
            'Accept': 'text/event-stream',
        };

        // Add authentication token if user is provided
        if (params.user && params.user.token) {
            headers["Authorization"] = params.user.token;

            // Add language header
            var lang = params.user && params.user._language
                ? `${params.user._language}-${params.user._language.toUpperCase()}`
                : "en";
            if (!params.user.language || !params.user.language) {
                lang = localStorage.getItem("active_language") || "en";
            }
            headers["Language"] = lang;
        } else {
            const lang = localStorage.getItem("active_language") || "en";
            headers["Language"] = lang;
        }

        // Perform fetch with SSE-specific configuration
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: body ? JSON.stringify(body) : null,
            signal: signal // Allow external cancellation via AbortController
        })
            .then(response => {
                // Check for authentication token update
                if (response.headers.has('X-Auth-Token')) {
                    const _user = JSON.parse(localStorage.getItem('user'));
                    _user.token = response.headers.get("X-Auth-Token");
                    localStorage.setItem('user', JSON.stringify(_user));
                }

                // Handle 401 Unauthorized
                if (response.status === 401) {
                    return response.json().then(data => {
                        if (data.redirectLogin) {
                            localStorage.removeItem("user");
                            window.location.href = "/login";
                            return Promise.reject(new Error('Unauthorized - redirecting to login'));
                        }
                        return Promise.reject(new Error('Unauthorized'));
                    });
                }

                // Return raw response for SSE stream processing
                // Consumer will handle reading the stream
                resolve(response);
            })
            .catch(error => {
                // Silent rejection - SSE errors are handled by consumer
                reject(error);
            });
    });
};

export { sendMessage, downloadFile, get_url, sendGetRequest, downloadFileGet, connectSSE };